export default "__VITE_ASSET__BWKIH2O6__"